import React from "react";
import { Bar, Line, Pie } from "react-chartjs-2";
import zoom from 'chartjs-plugin-zoom'
import { getBoundingClientRect } from "../../utils/functions";
import ReactStars from "react-rating-stars-component";
import TableViewer from "../../components/TableViewer";



class InquiryResult extends React.Component {
    state = {
        show: true,

        chart: [
            {
                img: '/assets/icons/line.svg',
                step: '0'
                // step: '5'
            },
            {
                img: '/assets/icons/Group 4.svg',
                step: '1'
            },
            {
                img: '/assets/icons/bar.svg',
                step: '2'
            },
            {
                img: '/assets/icons/rating.svg',
                step: '3'
            },
            {
                img: '/assets/icons/table.svg',
                step: '4'
            },
        ],

        data: {
            labels: [],
            datasets: []
        },
        headers: [
            { key: 'number', type: 'TextInput', information: { label: 'number' } },
            { key: 'answers', type: 'TextInput', information: { label: 'answers' } },
            { key: 'scores', type: 'TextInput', information: { label: 'scores' } },
            // { key: 'cDate', type: 'DateInput', information: { label: 'Creation Date' } },
            // { key: 'restrictions', type: 'TextInput', information: { label: 'Restrictions' } },
        ],


        chartOptions: {
            legend: {
                display: false
            },
            bezierCurve: false,


            zoom: {
                // enabled: true,
                // drag:true,
                mode: 'xy',
                overScaleMode: 'y',
                modifierKey: 'shift',

                wheel: {
                    enabled: false,
                    modifierKey: 'shift',

                },


                drag: {
                    enabled: true,
                    modifierKey: 'shift',

                },

                pinch: {
                    enabled: true,
                    modifierKey: 'shift',

                },


            },




            scales: {
                xAxes: [

                    {
                        gridLines: {
                            color: 'transparent',


                        },
                        ticks: {
                            beginAtZero: true,
                            fontColor: '#afafaf',
                            fontSize: 12,
                        }
                    },
                ],
                yAxes: [
                    {
                        gridLines: {
                            color: "#eeeeeeFF"

                        },
                        ticks: {
                            beginAtZero: true,
                            fontColor: '#afafaf',
                            fontSize: 12,
                        }
                    },
                ],


            }
        },

        stepitem: '0'

    }


    colors = [
        { backgroundColor: 'rgb(54, 162, 235)', borderColor: 'rgba(54, 162, 235, 0.2)' },
        { backgroundColor: 'rgb(255, 99, 132)', borderColor: 'rgba(255, 99, 132, 0.2)' },
        { backgroundColor: '#90aaee', borderColor: '#90aaee20' },
        { backgroundColor: 'rgb(255, 99, 132)', borderColor: 'rgba(255, 99, 132, 0.2)' },
        { backgroundColor: 'rgb(54, 162, 235)', borderColor: 'rgba(54, 162, 235, 0.2)' },
        { backgroundColor: '#90aaee', borderColor: '#90aaee20' }
    ]

    backgroundColors = ['rgb(255, 99, 132)', '#90aaee', 'rgb(255, 99, 132)', '#90aaee', 'rgb(255, 99, 132)', '#90aaee']


    componentDidMount() {
        window.addEventListener('resize', this.getSize)
        this.getSize()

        this.createData()
        // InquiryResult.register(zoom)
        // Bar.register(zoom)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.getSize)
    }

    createData = () => {
        let labels = []
        let datasets = [{ data: [], backgroundColor: this.backgroundColors }]

        let scores = this.props.data?.scores
        console.log(scores)
        if (scores) {

            for (const [key, value] of Object.entries(scores)) {
                console.log(value)
                labels.push('Label ' + key)
                datasets[0].data.push(value)
            }

            let data = this.state.data
            data.datasets = datasets
            data.labels = labels
            console.log(data)
            this.setState({ data, show: false }, () => {
                this.setState({ show: true })
            })
        }


    }

    getSize = () => {
        if (this.chartContainer) {
            let bound = getBoundingClientRect(this.chartContainer)

            this.setState({ show: false, height: bound.height, width: bound.width }, () => {
                this.setState({ show: true })
            })
        }
    }

    handleChengeChart = (key, value) => {
        this.setState({ [key]: value })
    }

    render() {
        return (
            <div className={'thingInfoList '}>

                <div className="w-100" style={{ borderRadius: 19, background: '#fff', padding: '0 8px', }}>
                    <div className="px-4" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                        <div className="d-flex">
                            <p>

                                {this.props.index + 1}.&nbsp;
                            </p>
                            <p>
                                {this.props.data?.name}

                            </p>
                        </div>

                        <div className="d-flex">
                            {this.state.chart.map((data) => {
                                return (
                                    <div className="mrd-1 flex-1 my-4 flexcc" onClick={() => this.setState({ stepitem: data.step })} style={{ cursor: 'pointer', padding: '3px 9px', borderRadius: 7, backgroundColor: this.state.stepitem == data.step ? '#eee' : '' }}>
                                        <img src={data.img} width={25} style={this.state.stepitem == data.step ? { filter: 'saturate(100%)' } : { filter: 'saturate(0%)' }} />
                                    </div>
                                )
                            })}
                        </div>
                    </div>

                    {/* <div style={{ border: '1px solid #ebeaf2', background: '#f9f9fb', borderRadius: 15 }}>
                        <div style={{ borderBottom: '1px solid #ebeaf2' }} className="d-flex justify-content-between p-3">
                            <div>
                                <p>Income and Expense</p>
                            </div>
                            <div>
                                <p>This Fiscal Year</p>
                            </div>
                        </div>
                        <div className="p-3">

                            <Bar
                                data={this.state.data}
                                options={this.state.chartOptions}
                                ref={el => this.chart = el}
                                height={this.state.width > 700 ? 130 : 200}
                            />
                        </div>
                        <div style={{ borderTop: '1px solid #ebeaf2', margin: '0 5%' }} />
                        <div style={{}} className="d-flex justify-content-between p-2">
                            <div className="w-100 flexcc flex-column">
                                <div>
                                    <div className="d-flex align-items-center">
                                        <div className="mrd-2" style={{ backgroundColor: 'rgb(237, 196, 86)', width: 25, height: '9px', }} />
                                        <p>Income</p>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div className="mrd-2" style={{ backgroundColor: 'rgb(169, 212, 125)', width: 25, height: '9px', }} />
                                        <p>Expense</p>
                                    </div>
                                </div>
                            </div>

                            <div style={{ borderRight: '1px solid #ebeaf2' }} />

                            <button className="w-100">
                                <p>Current</p>
                                <p>$0.00</p>
                            </button>

                            <button className="w-100">
                                <p>Overdue</p>
                                <p>$2,600.000</p>
                            </button>

                        </div>
                    </div> */}
                    {this.state.stepitem == '0' && (



                        this.state.show && (

                            <div ref={el => this.chartContainer = el} style={{}} className="col-12 p-3">

                                <Line
                                    data={this.state.data}
                                    options={this.state.chartOptions}
                                    ref={el => this.chart = el}
                                    // height={this.state.width > 700 ? 130 : 300}
                                    height={this.state.width > 500 ? '30%' : '100%'}
                                    width={'100%'}
                                    plugins={[zoom]}
                                    borderColor={'#ee5050'}

                                />

                            </div>
                        )



                    )}
                    {this.state.stepitem == '1' && (



                        this.state.show && (

                            <div ref={el => this.chartContainer = el} style={{}} className="col-12 p-3">
                                <Pie
                                    data={this.state.data}
                                    // options={this.state.chartOptions}
                                    ref={el => this.chart = el}
                                />
                            </div>
                        )



                    )}
                    {this.state.stepitem == '2' && (



                        this.state.show && (

                            <div ref={el => this.chartContainer = el} style={{}} className="col-12 p-3">

                                <Bar
                                    data={this.state.data}
                                    options={this.state.chartOptions}
                                    ref={el => this.chart = el}
                                    // height={this.state.width > 700 ? 130 : 300}
                                    height={this.state.width > 500 ? '30%' : '100%'}
                                    width={'100%'}
                                    plugins={[zoom]}
                                    borderColor={'#ee5050'}

                                />
                            </div>
                        )



                    )}
                    {this.state.stepitem == '3' && (



                        this.state.show && (

                            <div style={{}} className="col-12 p-3 flexc">
                                <div className="col-4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <ReactStars
                                        count={5}
                                        size={30}
                                        edit={false}
                                        value={4.8}
                                        isHalf={true}
                                        color="#eee"
                                        activeColor="#ffcc00"
                                    />
                                    <div>
                                        <p style={{ fontSize: 40, fontWeight: '800' }}>
                                            4.8
                                        </p>
                                    </div>
                                    <div>
                                        <p style={{ fontSize: 11 }}>out of 5</p>
                                    </div>
                                </div>
                                <div className="w-100 col-8" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                    <div className="w-100 d-flex align-items-center ">
                                        <div className="mrd-2">
                                            <ReactStars
                                                count={5}
                                                size={20}
                                                edit={false}
                                                value={5}
                                                isHalf={true}
                                                color="#eee"
                                                activeColor="#d0d0d0"
                                            />
                                        </div>
                                        <div style={{ background: '#f5f5f5', width: '60%', height: '9px', borderRadius: 50 }}>
                                            <div style={{ background: '#d0d0d0', width: '50%', height: '9px', borderRadius: '50px 0 0 50px' }}>

                                            </div>

                                        </div>
                                        <div>
                                            <p style={{ fontSize: 13, color: '#606060' }}>&nbsp;30%</p>
                                        </div>
                                    </div>
                                    <div className="w-100 d-flex align-items-center ">
                                        <div className="mrd-2">
                                            <ReactStars
                                                count={5}
                                                size={20}
                                                edit={false}
                                                value={4}
                                                isHalf={true}
                                                color="#eee"
                                                activeColor="#d0d0d0"
                                            />
                                        </div>
                                        <div style={{ background: '#f5f5f5', width: '60%', height: '9px', borderRadius: 50 }}>
                                            <div style={{ background: '#d0d0d0', width: '50%', height: '9px', borderRadius: '50px 0 0 50px' }}>

                                            </div>

                                        </div>
                                        <div>
                                            <p style={{ fontSize: 13, color: '#606060' }}>&nbsp;30%</p>
                                        </div>
                                    </div>
                                    <div className="w-100 d-flex align-items-center ">
                                        <div className="mrd-2">
                                            <ReactStars
                                                count={5}
                                                size={20}
                                                edit={false}
                                                value={3}
                                                isHalf={true}
                                                color="#eee"
                                                activeColor="#d0d0d0"
                                            />
                                        </div>
                                        <div style={{ background: '#f5f5f5', width: '60%', height: '9px', borderRadius: 50 }}>
                                            <div style={{ background: '#d0d0d0', width: '50%', height: '9px', borderRadius: '50px 0 0 50px' }}>

                                            </div>

                                        </div>
                                        <div>
                                            <p style={{ fontSize: 13, color: '#606060' }}>&nbsp;30%</p>
                                        </div>
                                    </div>
                                    <div className="w-100 d-flex align-items-center ">
                                        <div className="mrd-2">
                                            <ReactStars
                                                count={5}
                                                size={20}
                                                edit={false}
                                                value={2}
                                                isHalf={true}
                                                color="#eee"
                                                activeColor="#d0d0d0"
                                            />
                                        </div>
                                        <div style={{ background: '#f5f5f5', width: '60%', height: '9px', borderRadius: 50 }}>
                                            <div style={{ background: '#d0d0d0', width: '50%', height: '9px', borderRadius: '50px 0 0 50px' }}>

                                            </div>

                                        </div>
                                        <div>
                                            <p style={{ fontSize: 13, color: '#606060' }}>&nbsp;30%</p>
                                        </div>
                                    </div>
                                    <div className="w-100 d-flex align-items-center ">
                                        <div className="mrd-2">
                                            <ReactStars
                                                count={5}
                                                size={20}
                                                edit={false}
                                                value={1}
                                                isHalf={true}
                                                color="#eee"
                                                activeColor="#d0d0d0"
                                            />
                                        </div>
                                        <div style={{ background: '#f5f5f5', width: '60%', height: '9px', borderRadius: 50 }}>
                                            <div style={{ background: '#d0d0d0', width: '50%', height: '9px', borderRadius: '50px 0 0 50px' }}>

                                            </div>

                                        </div>
                                        <div>
                                            <p style={{ fontSize: 13, color: '#606060' }}>&nbsp;30%</p>
                                        </div>
                                    </div>



                                </div>
                            </div>
                        )



                    )}
                    {this.state.stepitem == '4' && (



                        this.state.show && (

                            <div style={{}} className="col-12 p-3">
                                <TableViewer
                                    // isLoading={this.state.isLoading}
                                    headers={this.state.headers}
                                    data={this.props.item}
                                    // actions={this.state.actions}
                                    // settings={{ isSortable: false }}
                                    // openEditModal={this.openEditModal}
                                    // openRemoveModal={this.openRemoveModal}
                                    // updateData={this.updateData}
                                    ref={el => this.TableViewer = el}
                                />
                            </div>
                        )



                    )}


                    {/*s<button className="text-smaller" style={{ color: '#007aff' }} onClick={() => this.changeZoomDirection()}>Reset Zoom</button> */}


                </div>

                <div style={{ margin: '10px 0' }} />

            </div>
        )
    }
}

export default InquiryResult;

